import { createDictionary } from './_base-dictionary'
export default createDictionary({
  resource: 'complexes/objects',
  parseResponse: res => res.data.list
})
